module.exports = __webpack_public_path__ + "static/media/21ECLAC27.37a97c40.jpg";